import * as types from '@/store/types'
export default {
    state: {
        eleAddress: {},
        eleEditAddress: {},
        eleShop: {},
        eleCart: {},
        eleLocalAdd: {},
        eleCity: '',
        eleLocalCity: '',
        eleCityList: [],
        eleKeyword: '',
        isxingbake: false,
        eleRefresh: false,
        eventData: {},
        shopDetail: {}
    },
    mutations: {
        [types.SET_ELE_ADDRESS]: (state, value) => {
            state.eleAddress = value
        },
        [types.SET_ELE_EDIT_ADDRESS]: (state, value) => {
            state.eleEditAddress = value
        },
        [types.SET_ELE_SHOP]: (state, value) => {
            state.eleShop = value
        },
        [types.SET_ELE_CART]: (state, value) => {
            state.eleCart = value
        },
        [types.ELE_LOCAL_ADD]: (state, value) => {
            state.eleLocalAdd = value
        },
        [types.ELE_CITY]: (state, value) => {
            state.eleCity = value
        },
        [types.ELE_CITY_LIST]: (state, value) => {
            state.eleCityList = value
        },
        [types.ELE_LOCAL_CITY]: (state, value) => {
            state.eleLocalCity = value
        },
        [types.ELE_KEYWORD]: (state, value) => {
            state.eleKeyword = value
        },
        [types.IS_XINGBAKE]: (state, value) => {
            state.isxingbake = value
        },
        [types.ELE_REFRESH]: (state, value) => {
            state.eleRefresh = value
        },
        [types.EVENT]: (state, value) => {
            state.eventData = value
        },
        [types.SHOP_DETAIL]: (state, value) => {
            state.shopDetail = value
        },
    },
    getters: {
        eleAddress: state => state.eleAddress,
        eleEditAddress: state => state.eleEditAddress,
        eleShop: state => state.eleShop,
        eleCart: state => state.eleCart,
        eleLocalAdd: state => state.eleLocalAdd,
        eleCity: state => state.eleCity,
        eleCityList: state => state.eleCityList,
        eleLocalCity: state => state.eleLocalCity,
        eleKeyword: state => state.eleKeyword,
        isxingbake: state => state.isxingbake,
        eleRefresh: state => state.eleRefresh,
        eventData: state => state.eventData,
        shopDetail: state => state.shopDetail,
    }
}